import styled from "styled-components";
import Link from "next/link";
import React from "react";
import {getTheme} from "../../shared/themeUtils";
import {useHeaderLinks} from "../../hooks/useHeaderLinks";
import {IHeaderLink} from "../../interfaces/IHeaderLinks";

const TopSection = styled.div`
    background-color: ${getTheme("colors.white")};
    padding: ${getTheme("space.1")} 0;
    color: ${getTheme("colors.secondaryFont")};
    border-bottom: 1px solid ${getTheme("colors.border")};
    font-size: ${getTheme("fontSizes.small")};

    @media (max-width: ${getTheme("breakpoints.1")}) {
        display: none;
    }
`

const Container = styled.div`
    .top-links {
        display: flex;
        justify-content: space-between;
    }

    .left .link {
        margin-right: ${getTheme("space.2")};
    }

    .right .link {
        margin-left: ${getTheme("space.2")};
    }

    .link-red {
        color: ${getTheme("colors.textRed")};
        font-weight: bold;
        opacity: .7;
    }

    .internal {
        color: ${getTheme("colors.textOrange")};
    }
`

export default function TopHeader() {
  const headerLinksQuery = useHeaderLinks();

  const getClasses = (link: IHeaderLink, classes: string) => {
    let cls = classes;
    if (link.internal) {
      cls += " internal"
    }
    if (link.href.includes("Blackfriday24")) {
      cls += " link-red"
    }

    return cls
  }

  return (
    <TopSection>
      <Container className={"appContainer"}>
        {headerLinksQuery.data &&
          <div className={"top-links"}>
            <div className="left">
              {headerLinksQuery.data.leftLinks && headerLinksQuery.data.leftLinks.map((link: IHeaderLink) => {
                return (
                  <Link className={getClasses(link, "link")} key={link.title}
                        href={`/${link.href}`} title={link.title}>{link.text}</Link>
                )
              })
              }
            </div>
            <div className="right">
              {headerLinksQuery.data?.rightLinks?.map((link: IHeaderLink) => {
                return (
                  <Link className={getClasses(link, "link")} key={link.title} href={`/${link.href}`}>{link.text}</Link>
                )
              })
              }
            </div>
          </div>
        }
      </Container>
    </TopSection>
  )
}